export default function SliderImages() {
  const sliders = document.querySelectorAll('.slider-images')
  const hero = document.querySelector('section.o-hero')
  const gallery = document.querySelector('.o-join-us__gallery')

  if (!sliders.length) return

  const MAX_WIDTH_FOR_SCROLL = 1023
  const FORCE_SCROLL_CLASS = 'contact'
  const SPEED_PX_PER_SECOND = 40

  const hasGallery = Boolean(gallery)

  const debounce = (func, delay) => {
    let timeoutId
    return function (...args) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        func.apply(this, args)
      }, delay)
    }
  }

  sliders.forEach((LIST, index) => {
    let animationFrame = null
    let isHovering = false
    let canScroll = false
    let isMobileOrTablet = false
    let scrollAccumulator = 0
    let lastTime = 0

    const direction = index % 2 === 0 ? 1 : -1

    const prepareInfiniteContent = () => {
      if (LIST.dataset.cloned === 'true') return

      if (LIST.children.length > 0) {
        const originalItems = Array.from(LIST.children)

        for (let i = 0; i < 1; i++) {
          originalItems.forEach((child) => {
            const clone = child.cloneNode(true)
            LIST.appendChild(clone)
          })
        }

        LIST.dataset.cloned = 'true'
      }
    }

    const checkScrollRequirement = () => {
      prepareInfiniteContent()

      const isContactSlider = LIST.classList.contains(FORCE_SCROLL_CLASS)

      if (hero || gallery) {
        isMobileOrTablet = true
      } else {
        isMobileOrTablet = window.innerWidth <= MAX_WIDTH_FOR_SCROLL
      }

      const shouldScrollBeForced = isContactSlider || isMobileOrTablet

      canScroll =
        shouldScrollBeForced &&
        (LIST.scrollWidth > LIST.clientWidth ||
          LIST.scrollWidth > window.innerWidth)

      if (canScroll) {
        if (!animationFrame) {
          lastTime = performance.now()
          startScroll(lastTime)
        }
      } else {
        stopScroll()
      }
    }

    const startScroll = (timestamp) => {
      if ((isHovering && !hasGallery) || !canScroll) return

      const deltaTime = timestamp - lastTime
      lastTime = timestamp

      const safeDelta = Math.min(deltaTime, 50)
      const step = (SPEED_PX_PER_SECOND / 1000) * safeDelta
      scrollAccumulator += step

      if (scrollAccumulator >= 1) {
        LIST.scrollLeft += Math.floor(scrollAccumulator) * direction
        scrollAccumulator -= Math.floor(scrollAccumulator)
      }

      const singleSetWidth = LIST.scrollWidth / 3

      if (direction === 1 && LIST.scrollLeft >= singleSetWidth * 2) {
        LIST.scrollLeft -= singleSetWidth
      }

      if (direction === -1 && LIST.scrollLeft <= 0) {
        LIST.scrollLeft += singleSetWidth
      }

      animationFrame = requestAnimationFrame(startScroll)
    }

    const stopScroll = () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame)
        animationFrame = null
      }
    }

    const debouncedCheck = debounce(checkScrollRequirement, 200)

    checkScrollRequirement()
    window.addEventListener('resize', debouncedCheck)
    window.addEventListener('load', checkScrollRequirement)

    LIST.addEventListener('mouseenter', () => {
      if (hasGallery) return
      isHovering = true
      stopScroll()
    })

    LIST.addEventListener('mouseleave', () => {
      if (hasGallery) return
      isHovering = false
      lastTime = performance.now()
      startScroll(lastTime)
    })
  })
}
